export default __webpack_public_path__ + "images/F1.27b6cba.png";